import { render, staticRenderFns } from "./FormTypeChoosePricing.vue?vue&type=template&id=2243b48a&"
import script from "./FormTypeChoosePricing.vue?vue&type=script&lang=js&"
export * from "./FormTypeChoosePricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports